import React from "react";
import "./Footer.css";
import { FaFacebookF, FaGithub, FaTelegramPlane, FaTwitter, FaInstagram } from "react-icons/fa";
import starlinkLogo from "../../assets/logo/starlinkLogoRemoveBg.png"; // Replace with actual path

const Footer = () => {
  return (
    <footer className="footer">
      <div className="newsletter">
        <h3 className="LatestNewsHeading">STAY UPDATED WITH OUR LATEST NEWS AND INSIGHTS.</h3>
        <div className="subscribe-box">
          <input type="email" placeholder="Enter your email Address" />
          <button className="FooterSubsribeButton">Subscribe</button>
        </div>
      </div>

      <div className="footer-content">
       
  <div className="footer-column logo-section">
          <img src={starlinkLogo} alt="StarlinkLab" className="logo" />
          {/* <h5>Follow us</h5>
          <div className="social-icons">
            <FaFacebookF className="facebookIcon"/>
            <FaGithub  className="githubIcon"/>
            <FaTelegramPlane className="telegramIcon"/>
            <FaTwitter  className="twitterIcon"/>
            <FaInstagram className="instagramIcon"/>
          </div> */}
        </div>
        <div className="footer-column">
          <h4 className="serviceHeading">Services</h4>
          <ul className="footer-mainUl-ListName">
            <li className="footer-first-listName">Web Development</li>
            <li className="footer-listName">UI/UX Services</li>
            <li className="footer-listName">Graphic Designing</li>
            <li className="footer-listName">Mobile App Development</li>
            <li className="footer-listName">CMS</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4 >Technologies</h4>
          <ul>
            <li>ReactJS</li>
            <li>Angular</li>
            <li>Figma</li>
            <li>WordPress</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Company</h4>
          <ul>
            <li>About Us</li>
            <li>Careers</li>
            <li>Services</li>
            <li>Teams</li>
            <li>Contact Us</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Industries</h4>
          <ul>
            <li>E-commerce</li>
            <li>Fitness</li>
            <li>Health</li>
            <li>Entertainment</li>
            <li>Designing</li>
          </ul>
        </div>

       {/* <div className="footer-contactDetails">
          <h4 className="footer-Title">Contact Us</h4>
          <p>📍 Gomti Nagar, Lucknow, 226010</p>
          <p>📧 contact.starlinklab@gmail.com</p>
          <p>📞 +91 9161284283</p>
        </div> */}
      </div>

      <div className="footer-bottom">
        <span>Innovate</span>
        <span>Inspire</span>
        <span>Create</span>
      </div>

      <p className="copyright">©2025 StarlinkLab. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
